module.exports = __webpack_public_path__ + "sm.svg?910e003cd97c5b4465447e0c3a9c812c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sm.svg
// module id = 937
// module chunks = 27